import 'babel-polyfill'
import Vue from 'vue'
import VueRouter from 'vue-router'
import App from './App.vue'

// importing vuetify
import vuetify from './plugins/vuetify'

// importing vuex store
import { store } from './store/store'

// importing the routes from the vue router
import { routes } from './routes'
Vue.use(VueRouter)
const router = new VueRouter({
  routes,
  mode: 'history'
})

Vue.config.productionTip = false

new Vue({
  vuetify,
  store,
  router,
  render: h => h(App)
}).$mount('#good3-app')
